export default __webpack_public_path__ + "pgnv-assets/6fc8b5ee550a60015d76105607531aab.png";